import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { usePortalPath } from '../hooks/usePortalPath'

// A redirect whose target is written as an absolute in-app path but resolved
// against the brand-portal base path (TDC-1609).
//
//   <PortalNavigate to="/dashboard" />   ->  /portal/acme/dashboard  (client)
//                                        ->  /dashboard             (internal)
//
// Route `path` strings are re-rooted mechanically by router/relativize.ts, but
// redirect targets are element props and can't be: some must stay root-absolute
// (/404, /403, /login, and the personal /settings tabs, which live outside the
// portal), while others name a page inside the portal. Keeping the target
// absolute here means it still reads like the route table and greps like it.
//
// Replaces RedirectPreservingSearch, whose query-preserving behaviour it keeps:
// a bare <Navigate to="/x"/> drops ?params, which silently ate deep links like
// /videos?video=123 through the /videos index redirect.
export function PortalNavigate({
  to,
  search: keepSearch = true,
  replace = true,
}: {
  to: string
  search?: boolean
  replace?: boolean
}) {
  const { p } = usePortalPath()
  const { search } = useLocation()
  return <Navigate to={{ pathname: p(to), search: keepSearch ? search : '' }} replace={replace} />
}
